import * as React from 'react';
import { OrderView } from 'components/Order';
import { Investment_IdeaType } from '../../../../../../../__generated__/globalTypes';
import { useActiveOrder } from './hook';

interface Props {
  id: number;
  ideaType: Investment_IdeaType;
}

export const ActiveOrder: React.FC<Props> = ({ id, ideaType }) => {
  const { order } = useActiveOrder(id, ideaType);

  return order ? <OrderView order={order} forIdeaPage /> : null;
};
